export const numericPattern = /^[\d+.-][\d\s+,.-]*[\d\s,.-]$/;
